export const FILTERS_STORAGE_KEY = 'live-ui-filters';
export const FILTERS_NOT_SET = null;

export function formatFilterData(list = []) {
  return list
    .map(item => item.selected ? item.id : null)
    .filter(item => item !== null);
}

export function initializeFilters(storedFilters, defaults) {
  if (storedFilters && storedFilters !== FILTERS_NOT_SET) {
    return {
      events: Array.isArray(storedFilters.events) ? storedFilters.events : (defaults?.events ?? []),
      lots: Array.isArray(storedFilters.lots) ? storedFilters.lots : (defaults?.lots ?? []),
      landmarks: Array.isArray(storedFilters.landmarks) ? storedFilters.landmarks : (defaults?.landmarks ?? [])
    };
  }

  return defaults;
}

export function syncFilterData(filterList, selectedIds, defaultIds) {
  if (!filterList) {
    return [];
  }
  
  const selected = Array.isArray(selectedIds) ? selectedIds : [];
  const defaults = Array.isArray(defaultIds) ? defaultIds : [];
  
  const hasSelections = selected.length > 0;
  const hasDefaults = defaults.length > 0;
  
  const matchesDefaults = hasDefaults && hasSelections &&
    selected.length === defaults.length && 
    selected.every(id => defaults.includes(id)) &&
    defaults.every(id => selected.includes(id));
  
  if (!hasSelections || matchesDefaults) {
    return filterList.map(item => ({
      ...item,
      selected: true
    }));
  }
  
  return filterList.map(item => ({
    ...item,
    selected: selected.includes(item.id)
  }));
}

